import React, { useState, useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import ProvinceFilter from './ProvinceFilter';
import DistanceFilter from './DistanceFilter';
import { FilterContext } from '../internal';

import { StyledLocationFilter, FilterPicker, LabelButton } from './Styles';

const LocationFilter = () => {
  const {
    filterMetaData: { locations, distances, buyerAddresses, showDistance },
    updateFilter,
    updateShowDistanceProvince
  } = useContext(FilterContext);
  const [provinceActive, setProvinceActive] = useState(!showDistance);
  const [distanceActive, setDistanceActive] = useState(showDistance);

  const isLabelActive = active => {
    return active ? 'selected' : 'unselected';
  };

  const handleLabelChange = () => {
    setProvinceActive(!provinceActive);
    setDistanceActive(!distanceActive);
    updateShowDistanceProvince(!distanceActive);
  };

  useEffect(() => {
    setProvinceActive(!showDistance);
    setDistanceActive(showDistance);
  }, [showDistance]);

  return (
    <StyledLocationFilter>
      <FilterPicker>
        <LabelButton
          variant={isLabelActive(provinceActive)}
          onClick={handleLabelChange}
          data-testid="province-label"
        >
          <FormattedMessage
            id="list.filters.province"
            values={{ provinceCount: 1 }}
          />
        </LabelButton>
        <LabelButton
          variant={isLabelActive(distanceActive)}
          onClick={handleLabelChange}
          data-testid="distance-label"
        >
          <FormattedMessage id="list.filters.distance" />
        </LabelButton>
      </FilterPicker>

      {provinceActive && (
        <ProvinceFilter provinces={locations} updateFilter={updateFilter} />
      )}

      {distanceActive && (
        <DistanceFilter
          distances={distances}
          buyerAddresses={buyerAddresses}
          updateFilter={updateFilter}
        />
      )}
    </StyledLocationFilter>
  );
};

export default LocationFilter;
